module.exports = __webpack_public_path__ + "static/media/24UHCHR3.69d8b72b.jpg";